export class VendorMissingBillStatusUpdateParametersDto {
    workflowMissingBillQueueId: number;
    isResolved: boolean;
    statusCode: string;
    // expectedValues: Empty, ActiveAcctCreditBal, ActiveAcctOnHold, DuplicateAcct, EFTRequestCopyOfBill, InactiveAcct, NonUtility, RequestCopyOfBill, ValidAcct, WrongAcct, WrongAssociation, WrongVendor
}
